import React from "react";
import { Form, Formik } from "formik";
import MultiFileUpload from "@poseidon/ui/components/MultiFileUpload";
import { useAuth } from "@poseidon/ui/components/AuthContext";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import * as api from "./api";

export function UploadNewFile({
  fileCategory,
  fileGroup,
  filePurposes,
  applicationId,
  agreementId,
  sailorId,
  dealerId,
  asDealer,
}) {
  const { user } = useAuth();
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();

  const onSubmitHandler = async (values, { resetForm }) => {
    const getFilePurpose = (values, index) => {
      if (values.filePurposes) {
        return values.filePurposes[index]?.value ?? null;
      }
      return null;
    };

    const getFileName = (values, file, index) => {
      if (values.fileNames[index]) {
        return (
          values.fileNames[index] +
          (values.fileExtensions[index]
            ? "." + values.fileExtensions[index]
            : "")
        );
      }
      return file.name;
    };

    try {
      const filesToUpload = values.filesToUpload.reduce((prev, file, index) => {
        return [
          ...prev,
          {
            file: new File([file], getFileName(values, file, index), {
              type: file.type,
            }),
            filePurpose: getFilePurpose(values, index),
          },
        ];
      }, []);

      await api.addFiles({
        fileCategory,
        fileGroup,
        files: filesToUpload,
        user,
        applicationId,
        agreementId,
        sailorId,
        dealerId,
        asDealer,
      });
      setToast("Files added");
      resetForm();
    } catch (error) {
      console.trace(error);
      setError(error.message);
    }
  };

  return (
    <Formik
      initialValues={{
        filesToUpload: [],
        filePurpose: filePurposes[0],
        fileNames: [],
        filePurposes: [],
      }}
      onSubmit={onSubmitHandler}
    >
      {({ values, isSubmitting, setFieldValue }) => {
        return (
          <Form>
            <MultiFileUpload
              values={values}
              setFieldValue={setFieldValue}
              isSubmitting={isSubmitting}
              filePurposes={filePurposes}
            />
          </Form>
        );
      }}
    </Formik>
  );
}
